<template>

<div>

    
    <div class="list-loader-outer">
        <transition name="loader-fade">
            <div class="list-loader" v-if="loading">
                <div class="loader"></div>
            </div>
        </transition>
    </div>

    <h1>Behandlingslängder</h1>

    <div class="searchbar">

    </div>

</div>


</template>


<script>

    export default {
        props: {
            query: {
                required: true
            },
            loading: {}
        },
        data: function () {
            return {
                search: {}
            }
        },
        methods: {

            updateQuery: function() {

                this.$emit('search', this.search);

            }
        },
        watch: {
            query: function() {

                this.search = this.query;

            }
        }
    }

</script>